module.exports = __webpack_public_path__ + "img/nuevo_a.23a5196c.png";